<template>
  <div id="hardware" v-if="country !== 'hongkong'">
    <div class="inner">
      <div class="top">
        <div class="top_box">
          <div class="top_title">{{ $t("home_hardware_title") }}</div>
          <div class="top_list">
            <div
              v-for="(item, idx) in topLists"
              :key="idx"
              class="top_list_item"
            >
              <div class="img_wrap">
                <img :src="item.imgSmall" class="top_list_item_img" />
              </div>
              <div class="img_title_title">
                {{ item.title }}
              </div>
              <div class="top_list_item_desc">
                {{ item.desc }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCountryByDomain } from "@/common/config";
export default {
  name: "HardwareView",
  data() {
    return {
      hoverIndex: null,
      topList: [
        {
          imgSmall: require("@/assets/Keeta2/example1@2x.png"),
          imgLarge: require("@/assets/Keeta2/Restaurant(large)@2x.png"),
          title: "home_hardware_12u_title",
          desc: "home_hardware_pos_desc",
        },
        {
          imgSmall: require("@/assets/Keeta2/example2@2x.png"),
          imgLarge: require("@/assets/Keeta2/Pub(large)@2x.png"),
          title: "home_hardware_8u_title",
          desc: "home_hardware_pos_desc",
        },
        {
          imgSmall: require("@/assets/Keeta2/example3@2x.png"),
          imgLarge: require("@/assets/Keeta2/Store(large)@2x.png"),
          title: "home_hardware_12u_title",
          desc: "home_hardware_pos_desc",
        },
        {
          imgSmall: require("@/assets/Keeta2/example4@2x.png"),
          imgLarge: require("@/assets/Keeta2/Casinos(large)@2x.png"),
          title: "home_hardware_8u_title",
          desc: "home_hardware_pos_desc",
        },
      ],
    };
  },
  computed: {
    country() {
      return getCountryByDomain(window.location.hostname);
    },
    topLists() {
      return this.topList.map((item) => ({
        imgSmall: item.imgSmall,
        imgLarge: item.imgLarge,
        title: this.$t(item.title),
        desc: this.$t(item.desc),
      }));
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/styles/_variables.scss";
#hardware {
  // width: 100%;
  min-width: $min-width;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 0 140px 0;
  background-color: #ffffff;
  .inner {
    width: 1200px;
  }

  .top {
    display: flex;
    flex-direction: column;
    align-items: center;
    .top_box {
      width: 100%;
      min-width: 431px;
      .top_title {
        color: #000;
        font-weight: 900;
        font-size: 1.3rem;
        font-family: $title-font;
      }
    }
    .top_list {
      display: flex;
      margin-top: 50px;
    }
    .top_list_item {
      min-width: 280px;
      margin-left: 26px;
      &:first-child {
        margin-left: 0;
      }
      .img_wrap {
        height: 501px;
        .top_list_item_img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 20px;
        }
      }
      .img_title_title {
        font-weight: 600;
        font-size: $font-size-small;
        margin: 30px 0 15px 0;
        font-family: $content-font;
      }
      .top_list_item_desc {
        width: 290px;
        font-weight: 400;
        font-size: $font-size-mini;
        line-height: 28px;
        color: #999999;
        font-family: $content-font;
      }
    }
  }
}
</style>